import React, { useContext } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button } from "@mui/material";
import { StateManagerContext } from "./StateManagerContext";

export type CheckoutFormProps = {
    clientSecret : string;


};

export const CheckoutForm = ({ clientSecret} : CheckoutFormProps) : JSX.Element => {
    const stripe = useStripe();
    const elements = useElements();

    const stateManager = useContext(StateManagerContext);

    const makePayment = async () => {
        if(!stripe || ! elements)
            return;

        const storedPayment = { token : clientSecret, userId : stateManager.user().fanbox.id};

        sessionStorage.setItem('Fanbox.StoredPayment',JSON.stringify(storedPayment))

        const { error } = await stripe.confirmPayment( {
            confirmParams : {
                return_url : 'http://localhost:3000/'
            },
            elements : elements
        })
    }

    return (
        <div>
            <PaymentElement/>
            <Button onClick={() => { makePayment(); }}
      sx={{
        borderRadius: '25px',
        width: '92px',
        minWidth: '92px',
        maxWidth: '92px',
        height: '48px',
        minHeight: '48px',
        maxHeight: '48px',
        color: 'black',
        fontSize: '18px',
        fontWeight: 400,
        backgroundColor: '#92CA36'
      }} >Pay</Button>
        </div>

    );

}